import { render } from "./RequisitoTela.vue?vue&type=template&id=85435ef2&scoped=true"
import script from "./RequisitoTela.vue?vue&type=script&lang=js"
export * from "./RequisitoTela.vue?vue&type=script&lang=js"

import "./RequisitoTela.vue?vue&type=style&index=0&id=85435ef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85435ef2"]])

export default __exports__